export class Contact {
    public name: string;
    public email: string;
    public pic: string;
    public id: number;
}
